var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_20288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_958_20288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0933 41.0667L17 16.0469L42 16.0972L39.7865 41.0667L29.5944 43.9529L19.0933 41.0667Z",
    fill: "#1B73BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5938 41.5365V18.4297L39.8889 18.4632L38.053 39.1369L29.5938 41.5365Z",
    fill: "#1C88C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 21.3828H21.4961L21.9251 24.4031H29.4404L22.0453 27.5076L22.4741 30.4274H33.3699L32.9751 34.505L29.286 35.2099L25.9402 34.3709L25.6828 32.0551H22.6114L23.0231 36.8712L29.612 38.6667L35.9265 36.7034L36.733 27.2894H30.058L37.3332 24.3361L37.3334 21.3828Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_20288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_958_20288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 28,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow12);
export default __webpack_public_path__ + "static/media/row-1-2.981e70663779ceb9388c64975c581f73.svg";
export { ForwardRef as ReactComponent };